// extracted by mini-css-extract-plugin
export default {"lea-c-service-case-header":"service-case-header---8512c602"};